<template>
  <div class="StudentManagement">
    <p style="text-align: left; margin-bottom: 30px;"><el-button type="primary"
        @click="AddStudentManagement" icon="el-icon-plus" size="small" class="btns">添加</el-button></p>
    <el-table :data="tableData" border style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
      <el-table-column prop="manageName" label="课管" width="180">
      </el-table-column>
      <el-table-column prop="marketName" label="销售">
      </el-table-column>
      <el-table-column prop="teacherName" label="老师">
      </el-table-column>
      <el-table-column prop="categoryNames" label="科目">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="edit(scope.row.id,'详情')">详情</el-button>
          <el-button type="text" size="small" @click="edit(scope.row.id,'编辑')">编辑</el-button>
          <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paging.pageNum"
      :page-size="paging.pageSize" layout="total, prev, pager, next" :total="total">
    </el-pagination>
    <!-- 添加编辑 -->
    <el-dialog :title="titleisShow" :visible="dialogFormVisible" width="50%" style="text-align: left;">
      <el-form label-width="70px">
        <el-form-item label="课管">
          <el-select v-model="managementObj.manageId"  style="width: 80%;" placeholder="请选择课管" :disabled="isDisable">
            <el-option v-for="item in classTeacher" :value="item.id" :key="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售">
          <el-select v-model="managementObj.marketIds" style="width: 80%;" multiple placeholder="请选择销售" :disabled="isDisable">
            <el-option v-for="item in marketArr" :value="item.id" :key="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教师">
          <el-select v-model="managementObj.teacherIds" multiple placeholder="请选择教师(教师可多选)" style="width:80%;" :disabled="isDisable">
            <el-option v-for="item in teacherArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目">
          <el-select v-model="managementObj.categoryIds" multiple placeholder="请选择科目(科目可多选)" style="width:80%;" :disabled="isDisable">
            <el-option v-for="item in teacherArrr" :key="item.id" :value="item.id" :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template v-slot:footer>
        <div  class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="save" v-if="!isDisable">确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible="flog" width="40%" style="text-align: left;">
      <el-form label-width="70px">
        <el-form-item label="课管">
          {{ this.manageName }}
        </el-form-item>
        <el-form-item label="销售">
          {{ this.marketName }}
        </el-form-item>
        <el-form-item label="教师">
          {{ this.teacherName }}
        </el-form-item>
        <el-form-item label="科目">
          {{ this.categoryNames }}
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button @click="flog = false">取 消</el-button>
          <el-button type="primary" @click="flog = false">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getDataList, getTeachers, AddSave, editSave, getDetails, delItem } from "@/api/StudentManagementApi"
import { getSubject, } from "@/api/firstClassApi";
export default {
  data () {
    return {
      isDisable: false,
      dialogFormVisible: false,//控制显示隐藏
      isShow: true,
      flog: false,
      teacherName: "",
      categoryNames:'',
      manageName: '',
      marketName: '',
      managementObj: {
        manageId: [],//课管ID
        teacherIds: [],//老师ID
        marketIds: [],
        categoryIds: [],
        id: ''
      },
      tableData: [],//table表格数据
      teacherArr: [],//所有老师
      classTeacher: [],//所有课管
      marketArr: [],//所有销售
      total: 0,
      paging: {///分页
        pageNum: 1,
        pageSize: 10,
      },


      titleisShow:'',
      teacherArrr: [],
    }
  },
  created () {
    this.getList()
    this.getTeacherList()
  },

  mounted () {
    getSubject().then((res) => {  this.teacherArrr = res.data })
  },
  methods: {
    //获取table表格数据
    getList () {
      getDataList(this.paging).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    //获取所有老师
    getTeacherList () {
      getTeachers().then(res => {
        this.teacherArr = res.data
        this.classTeacher = res.data
        this.marketArr = res.data
      })
    },
    //添加按钮
    AddStudentManagement () {
      this.isShow = true
      this.isDisable = false
      this.dialogFormVisible = true
      this.titleisShow = '添加'
      this.managementObj = {}
    },
    //编辑回显
    edit (id,type) {

      if(type === '详情'){
        this.titleisShow = '详情'
        this.isDisable = true
      }

      if(type === '编辑'){
        this.titleisShow = '编辑'
        this.isDisable = false
      }

      this.isShow = false
      this.dialogFormVisible = true
      this.managementObj.id = id

      getDetails(id).then(res => {

        if(res.code === 200){
          this.managementObj.manageId = (res.data && res.data.manageId) ? res.data.manageId : ''
          this.managementObj.teacherIds = (res.data && res.data.teacherIds) ? res.data.teacherIds.split(",").map(id => parseInt(id)) : []
          this.managementObj.marketIds = (res.data && res.data.marketIds) ? res.data.marketIds.split(",").map(id => parseInt(id)) : []
          this.managementObj.categoryIds = (res.data && res.data.categoryIds) ? res.data.categoryIds.split(",").map(id => parseInt(id)) : []
        }else{
          this.managementObj.manageId = ''
          this.managementObj.teacherIds = []
          this.managementObj.marketIds = []
          this.managementObj.categoryIds = []
        }

      })

    },
    //详情
    details (id) {
      this.flog = true

      getDetails(id).then(res => {
        this.manageName = res.data.manageName
        this.teacherName = res.data.teacherName
        this.marketName = res.data.marketName
        this.categoryNames = res.data.categoryNames
      })

    },
    //保存
    save () {

      this.managementObj.teacherIds = this.managementObj.teacherIds.join(',')
      this.managementObj.marketIds = this.managementObj.marketIds.join(',')
      this.managementObj.manageId = this.managementObj.manageId
      this.managementObj.categoryIds = this.managementObj.categoryIds.join(',')

      if (this.isShow) {
        //添加保存
        AddSave(this.managementObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.managementObj= {  manageId: [], teacherIds: [], marketIds: [],  id: ''  }
            this.dialogFormVisible = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        //编辑保存
        editSave(this.managementObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.managementObj= {  manageId: [], teacherIds: [], marketIds: [],  id: ''  }
            this.dialogFormVisible = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    //删除
    del (id) {
      delItem(id).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleSizeChange () {

    },
    handleCurrentChange (v) {
      this.paging.pageNum = v;
      this.getList();
    },
  }
}
</script>

<style scoped>
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/StudentManagement.vue